import { ActionPermissions } from '../@types/permission.type';
import { TradingHourTypes } from '../components/molecules/TradingHours';
import { CapacityHourTypes } from '../components/organisms/Capacity';
import { ColumnSelectionItem } from '../components/templates/ColumnSelection';
import { PropertyType, ServiceCreationRuleTypes, SpecialServiceTasksEnum } from '../configs/enums';

export const LOCATION_MERGE_WARNING_MESSAGE = 'The Selected Node will be merged into this node, and all associated child nodes, Services, Shipments, Parts etc will be updated';

export const SAMPLE_STRUCTURE_LAYOUT = {
  name: '',
  notes: '',
  selectedTags: [],
  newTags: [],
  referenceNo1: '',
  referenceNo2: '',
  referenceNo3: '',
  siteSchemaId: '0',
  zone: '',
  region: ''
};

export const SAMPLE_CAPACITY_DATA = {
  type: CapacityHourTypes.AllDays,
  checkInventory: true,
  allowOveride: true,
  max: '4',
  itemsData: [],
  clientsData: [],
  contractsData: [],
};

export const STRUCTURE_ATTRIBUTE_TYPE_FIELDS: Array<string> = [
  PropertyType.Contact,
  PropertyType.Address,
  PropertyType.TradingHours,
  PropertyType.ReferenceNumbers,
  PropertyType.SiteSchema
];

export const SERVICE_CREATION_RULE_TYPES = [
  { value: ServiceCreationRuleTypes.Reference1, label: 'Reference 1' },
  { value: ServiceCreationRuleTypes.Reference2, label: 'Reference 2' },
  { value: ServiceCreationRuleTypes.Reference3, label: 'Reference 3' },
  { value: ServiceCreationRuleTypes.FaultAndDescription, label: 'Fault Code and Description' },
  { value: ServiceCreationRuleTypes.Model, label: 'Model' },
  { value: ServiceCreationRuleTypes.SerialNumber, label: 'Serial Number' },
  { value: ServiceCreationRuleTypes.Notes, label: 'Notes' },
];

export const ADDRESS_CONTACT_TYPES = [
  { label: 'Main', value: 'Main' },
  { label: 'Logistics', value: 'Logistics' },
  { label: 'Alternative', value: 'Alternative' },
  { label: 'Technical', value: 'Technical' },
  { label: 'Management', value: 'Management' },
  { label: 'Notification', value: 'Notification' }
];

export const MAIN_ADDRESS_CONTACT_TYPE = { label: 'Main', value: 'Main' };

export const SITE_SCHEMA_SAMPLE_DATA = [
  {
    id: 0,
    name: '',
    description: ''
  }
];

export const STRUCTURE_IMPORT_TOGGLE_BUTTONS = [
  {
    id: 1,
    toggleName: 'Show Error records'
  },
  {
    id: 2,
    toggleName: 'Show Createable records'
  },
  {
    id: 3,
    toggleName: 'Show Updateable records'
  },
];

export const STRUCTURE_IMPORT_TOGGLE_BUTTON_VALUES = [
  {
    id: 1,
    value: true
  },
  {
    id: 2,
    value: true
  },
  {
    id: 3,
    value: true
  },
];

export const STRUCTURE_IMPORT_DATA = {
  fileName: '',
  fileSize: 0,
  fileId: 0,
  sessionId: 0,
  preprocessingStatus: '',
  processingStatus: '',
  preprocessingErrorMessage: '',
  processingErrorMessage: ''
};

export const STRUCTURE_MERGE_LOCATION_NODE_SAMPLE_DATA = {
  id: 0,
  name: '',
  code: '',
  structureName: '',
  nodeTypeCode: '',
  mainAddress: '',
  reference1: '',
  logoPic: '',
  canHaveAddress: false,
  canHaveContact: false,
  canHaveTradingHours: false,
};

export const LOCATION_MERGE_DROPDOWN_ITEMS = [
  { label: 'Discard', value: 'discard' },
  { label: 'Copy Inbound', value: 'copy-inboud' },
  { label: 'Overwrite', value: 'overwrite' }
];

export const STRUCTUE_MERGE_DECISION_SAMPLE_DATA = {
  addressesDecision: '-1',
  contactsDecision: '-1',
  tradingHoursDecision: '-1',
  mergeNodeId: 0,
  currentNodeId: 0
};

export const columnSelectionItems: ColumnSelectionItem[] = [
  {
    title: 'General',
    value: [
      {
        title: 'Node ID',
        field: 'id',
        value: false
      },
      {
        title: 'Node Name',
        field: 'name',
        value: true
      },
      {
        title: 'Node Type',
        field: 'nodeTypeName',
        value: true
      },
      {
        title: 'Tags',
        field: 'structureTags',
        value: false
      },
      {
        title: 'Notes',
        field: 'notes',
        value: false
      },
      {
        title: 'Region Type',
        field: 'regionType',
        value: true
      },
      {
        title: 'Zone',
        field: 'zone',
        value: true
      },
      {
        title: 'Main Address',
        field: 'mainAddress',
        value: true
      },
      {
        title: 'All Addresses',
        field: 'allAddresses',
        value: false
      },
      {
        title: 'Main Contact',
        field: 'mainContact',
        value: true
      },
      {
        title: 'All Contacts',
        field: 'allContacts',
        value: false
      },
      {
        title: 'Trading Hours',
        field: 'tradingHrs',
        value: false
      },
      {
        title: 'Active',
        field: 'isActive',
        value: false
      },
      {
        title: 'Site Schema',
        field: 'siteSchema',
        value: false
      },
      {
        field: 'importsessionId',
        title: 'Import Session ID',
        value: false
      }
    ]
  },
  {
    title: 'Hierarchy',
    value: [
      {
        title: 'Parent Node ID',
        field: 'parentNodeId',
        value: false
      },
      {
        title: 'Parent Node Type',
        field: 'parentNodeTypeName',
        value: false
      },
      {
        title: 'Parent Node Name',
        field: 'parentName',
        value: true
      },
      {
        title: 'Parent Active',
        field: 'parentActive',
        value: false
      },
      {
        title: 'Client/ Contract/ Brand',
        field: 'clientContractBrand',
        value: true
      },
      {
        title: 'Client',
        field: 'client',
        value: true
      },
      {
        title: 'Contract',
        field: 'contract',
        value: true
      },
      {
        title: 'Brand',
        field: 'brand',
        value: true
      },
      {
        title: '# of Children (direct)',
        field: 'directChildCount',
        value: false
      },
      {
        title: '# of Children (total)',
        field: 'totalChildCount',
        value: false
      }
    ]
  },
  {
    title: 'Reference Numbers',
    value: [
      {
        title: 'Reference Number 1',
        field: 'referenceNo1',
        value: true
      },
      {
        title: 'Reference Number 2',
        field: 'referenceNo2',
        value: true
      },
      {
        title: 'Reference Number 3',
        field: 'referenceNo3',
        value: false
      }
    ]
  },
  {
    title: 'Presentation',
    value: [
      {
        title: 'Presentation',
        field: 'presentationValue',
        value: false
      },
      {
        title: 'Presentation Date',
        field: 'presentationDate',
        value: false
      }
    ]
  },
  {
    title: 'Parts',
    value: [
      {
        title: 'Quantity Stock (Good)',
        field: 'goodPartCount',
        value: false
      },
      {
        title: 'Quantity Stock (Total)',
        field: 'partCount',
        value: false
      }
    ]
  },
  {
    title: 'Misc',
    value: [
      {
        title: 'Created At',
        field: 'createdAt',
        value: false
      },
      {
        title: 'Created By',
        field: 'createdBy',
        value: false
      },
      {
        title: 'Updated At',
        field: 'updatedAt',
        value: false
      },
      {
        title: 'Updated By',
        field: 'updatedBy',
        value: false
      }
    ]
  },
  {
    title: 'Labels',
    value: [
      {
        title: 'Print Label',
        field: 'printLabel',
        value: false
      }
    ]
  }
];

export const SAMPLE_SITE_SCHEMA = {
  nodeId: -1,
  propertyTypeCode: 'site-schema',
  name: '',
  description: '',
  isActive: true,
  siteSchemaItems: []
};

export const EXPLICIT_SERVICE_STATUS_TRANSITIONS = [
  {
    ruleId: 0,
    selectedServiceType: '',
    selectedServiceStatus: '',
    selectedPriorities: [],
    selectedActionTypes: [],
    blockedStatuses: [],
    isActive: false
  }
];

export const SPECIAL_SERVICE_TASKS = [
  { value: SpecialServiceTasksEnum.MultiOnSiteSuggestions, label: 'Multi On Site Suggestions', additionalDataLabel: 'Multi On Site Suggestions - Label' },
  { value: SpecialServiceTasksEnum.SpecialFileUpload, label: 'Special File Upload', additionalDataLabel: 'Special File Upload - Allowed File Types' },
  { value: SpecialServiceTasksEnum.WorkOrderRequest, label: 'Work Order Request', additionalDataLabel: 'Work Order Request - Label' },
  { value: SpecialServiceTasksEnum.MultipleChildServiceCreation, label: 'Multiple Child Service Creation', additionalDataLabel: 'Multiple Child Service Creation - Label' },
  { value: SpecialServiceTasksEnum.CreateChildrenOnCreateStructureLocation, label: 'Create Children on Create Structure Location', additionalDataLabel: 'Create Children on Create Structure Location - Label' },
  { value: SpecialServiceTasksEnum.StructureCreationTypes, label: 'Structure Creation Types', additionalDataLabel: 'Structure Creation Types - Label' }
];

export const EXPLICIT_SERVICE_TYPE_MAPPINGS = [
  {
    mapId: 0,
    mappedName: '',
    selectedServiceType: '',
    selectedActionType: '',
    selectedProcessType: '',
    isAvailable: false
  }
];

export const SAMPLE_EDIT_STRUCTURE_PERMISSION_SET = {
  hasActiveInactiveEditPermission: false,
  hasNameEditPermission: false,
  hasTagsEditPermission: false,
  hasNotesEditPermission: false,
  hasReference1EditPermission: false,
  hasReference2EditPermission: false,
  hasReference3EditPermission: false,
  hasContractAddressEditPermission: false,
  hasTradingHoursEditPermission: false,
  hasViewChildrenEditPermission: false,
  hasViewPartsEditPermission: false,
  hasViewServicesEditPermission: false,
  hasViewShipmentsEditPermission: false,
  hasAllowMergeEditPermission: false,
  hasCapacityEditPermission: false,
  hasGlobalReturnEditPermission: false,
};

export const HAS_STRUCTURE_EDIT_PERMISSIONS = {
  hasActiveInactiveEditPermission: ActionPermissions.Structure_Edit_Parameter_Active_Inactive,
  hasNameEditPermission: ActionPermissions.Structure_Edit_Parameter_Name,
  hasTagsEditPermission: ActionPermissions.Structure_Edit_Parameter_Tags,
  hasNotesEditPermission: ActionPermissions.Structure_Edit_Parameter_Notes,
  hasReference1EditPermission: ActionPermissions.Structure_Edit_Parameter_Reference1,
  hasReference2EditPermission: ActionPermissions.Structure_Edit_Parameter_Reference2,
  hasReference3EditPermission: ActionPermissions.Structure_Edit_Parameter_Reference3,
  hasContractAddressEditPermission: ActionPermissions.Structure_Edit_Parameter_Contact_and_Address,
  hasTradingHoursEditPermission: ActionPermissions.Structure_Edit_Parameter_Trading_Hours,
  hasViewChildrenEditPermission: ActionPermissions.Structure_Edit_Parameter_View_Children,
  hasViewPartsEditPermission: ActionPermissions.Structure_Edit_Parameter_View_Parts,
  hasViewServicesEditPermission: ActionPermissions.Structure_Edit_Parameter_View_Services,
  hasViewShipmentsEditPermission: ActionPermissions.Structure_Edit_Parameter_View_Shipments,
  hasAllowMergeEditPermission: ActionPermissions.Structure_Edit_Allow_Merge,
  hasCapacityEditPermission: ActionPermissions.Structure_Edit_Parameter_Capacity,
  hasGlobalReturnEditPermission: ActionPermissions.Structure_Edit_Parameter_Global_Return
};

export const SAMPLE_REGION_OVERRIDES = [
  {
    overrideId: 0,
    postCode: '',
    suburbName: '',
    regionOverride: '',
    isActive: false
  }
];

export const ADDRESS_DEFAULT_CLIENT_CUSTOMER = {
  addressType: 'Main',
  isManual: false,
  isActive: true,
  googleAddress: '',
  name: '',
  contactNumber: '',
  email: '',
  contactCompany: '',
  line1: '',
  line2: '',
  suburb: '',
  city: '',
  postCode: '',
  countryId: 0,
  countryName: '',
  stateId: 0,
  stateName: ''
};

export const TRADING_HOURS_DEFAULT_CLIENT_CUSTOMER = {
  type: TradingHourTypes.Weekdays,
  start: '9:00am',
  end: '5:00pm',
  ph: false
};

export const CHILD_LOCATION_DEFAULT_CLIENT_CUSTOMER = {
  selectedStructureType: '',
  childrenLocations: [
    {
      name: '',
      reference1: '',
      reference2: '',
      reference3: ''
    }
  ]
};